import { render } from "./SurveyQuestionText.vue?vue&type=template&id=184f69c7&scoped=true"
import script from "./SurveyQuestionText.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionText.vue?vue&type=script&lang=js"

import "./SurveyQuestionText.vue?vue&type=style&index=0&id=184f69c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-184f69c7"

export default script